<template>
  <!-- <v-navigation-drawer
    fixed
    app
    right
    class="accent"
    pb-5
    permanent
    width="280"
    mini-variant-width="100"
    :mini-variant.sync="mini"
  > -->
    <!-- <v-toolbar color="accent" clipped-right>
      <v-btn flat @click="toLogout">Logout
        <v-icon color="primary" right>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>  xs5 md4 lg3 xl2 -->
    <v-flex class="my-3">
      <outputBitrates
        v-if="inBitrate !== null"
        :groupTitle="inBitrate.title"
        :params="inputBitreitai()"
      ></outputBitrates>
      <outputBitrates
        v-if="outBitrate !== null"
        :groupTitle="outBitrate.title"
        :params="outputBitreitai()"
      ></outputBitrates>
      <v-card color="primary" class="pa-1 ma-1 elevation-7">
        <v-list dense class="ma-0 pa-0">
          <v-list-item-group v-for="(item,groupindex) in items" :key="item.id" v-model="drawer"  >
            <template slot="activator">
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-bold">{{item.title}}</v-list-item-title>
                
              </v-list-item-content>
              <!-- <v-list-tile-action>
                <v-btn icon @click.stop="mini = !mini">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-list-tile-action>-->
            </template>

            <v-list-item pa-0 v-for="(param,paramIndex) in item.params" :key="paramIndex" >
              <!-- <v-list-tile-action>
                <v-icon color="primary">arrow_right</v-icon>
              </v-list-tile-action>-->
              <v-list-item-content class="ma-0 pa-0">
                <v-list-item-title class="body-2 grey--text font-weight-bold ">{{ param.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="ma-0 pa-0"> 
                <v-list-item-subtitle v-if="getValue[groupindex].params[paramIndex]"
                  class="primary--text caption font-weight-bold"
                >{{getValue[groupindex].params[paramIndex].value + " " + param.dimmension}}</v-list-item-subtitle>
              </v-list-item-action>
              
            </v-list-item>
            
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-flex>
  <!-- </v-navigation-drawer> -->
</template>

<script>
import lineStatus from "./lineStatus";
import outputBitrates from './outputBitrates'

export default {
  name: "statusParams",
  components: {
    lineStatus,
    outputBitrates
  },
  data() {
    return {
      panel: [true],
      drawer: true,
      mini: false
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    // toLogout: function() {
    //   this.$store.commit("setLogin", false);
    //   this.$http
    //     .get("login.cgi", {
    //       params: {
    //         cmd: "logout"
    //       }
    //     })
    //     .then(
    //       function(response) {
    //         this.$store.commit("setSalt", response.data.salt);
    //       },
    //       function(error000) {
    //         console.log("getlogin: " + error000.statusText);
    //       }
    //     );
    //   this.$cookie.delete("session");
    // },
    checkInBitrateSupport: function(specFuncName) {
      var SpecFunc = null;
      this.$store.getters.getActiveGroups.forEach(function(item) {
        if (item.specFunc && item.specFunc === specFuncName) SpecFunc = item;
      });
      return SpecFunc;
    },
    inputBitreitai: function() {
      if (this.inBitrate) {
        return this.inBitrate.params.map(function(item) {
          return {
            title: item.title,
            curr: parseFloat(
              this.$store.getters.getStatusParamValue(
                this.inBitrate.id,
                item.id
              )
            ),
            max: parseFloat(item.maxBitrate)
          };
        }, this);
      }
    },
    outputBitreitai: function() {
      if (this.outBitrate) {
        return this.outBitrate.params.map(function(item) {
          return {
            title: item.title,
            curr: parseFloat(
              this.$store.getters.getStatusParamValue(
                this.outBitrate.id,
                item.id
              )
            ),
            max: parseFloat(item.maxBitrate)
          };
        }, this);
      }
    }
  },
  computed: {
    getValue: function() {
      return this.$store.getters.getStatusGrpsValue;
    },
    inBitrate: function() {
      return this.checkInBitrateSupport("inBitrateGrp");
    },
    outBitrate: function() {
      return this.checkInBitrateSupport("outBitrateGrp");
    }
  }
};
</script>

